import React from 'react';
import { Box, Typography } from '@mui/material';
import { StepContentProps } from '@pages/LeadScraper/types';

const EmailConfigStep: React.FC<StepContentProps> = ({ isActive, handleNext }) => {
  if (!isActive) return null;

  // Placeholder implementation
  React.useEffect(() => {
    // Auto-proceed to next step for now
    const timer = setTimeout(() => {
      handleNext();
    }, 100);
    return () => clearTimeout(timer);
  }, [handleNext]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6">Email Configuration</Typography>
      <Typography variant="body2" color="textSecondary">
        Email configuration step - to be implemented
      </Typography>
    </Box>
  );
};

export default EmailConfigStep;